import React from "react";
import { FlexContainer, LottieLoadingIndicator } from "src/components";
import { USER_TYPE_EMPLOYEES, USER_TYPE_CLIENTS } from "src/constants/chat";
import { StyledButton } from "./CreateChatModal";

const SelectUsersSection = ({
    loadingFetchUsers,
    usersList,
    handleClose,
    handleSubmit,
    children,
    currentUserType,
    handleShowDeleteConfirmationModal = null,
    openedMatrixChat = null,
    isEdit = false,
    hideFooter = false
}) => {
    if (loadingFetchUsers) {
        return (
            <FlexContainer style={{ height: "20vh", justifyContent: "center", textAlign: "center" }}>
                <LottieLoadingIndicator />
            </FlexContainer>
        );
    }

    const renderFooterAction = (isShowMessageButton = false) => {
        return (
            <FlexContainer
                direction="row"
                justifyContent={isEdit ? "space-between" : "flex-end"}
                bottom="0.5rem"
                right="2rem"
                style={{
                    minHeight: "3.5rem",
                    paddingTop: "1rem",
                    borderTop: "1px solid var(--calendar-border, #D8DEEC)",
                    gap: "0.75rem",
                    flexWrap: "wrap",
                    alignItems: "center"
                }}
            >
                {isEdit && (
                    <div>
                        <StyledButton backgroundColor="#FF5353" color="#FFF"
                            onClick={() => handleShowDeleteConfirmationModal(openedMatrixChat)}
                        > Delete Group
                        </StyledButton>
                    </div>
                )}
                <div style={{ display: "flex", justifyContent: "end", gap: "0.75rem", flexWrap: "wrap", marginLeft: "auto" }}>
                    <StyledButton
                        backgroundColor="var(--calendar-surface, #FFF)"
                        color="var(--calendar-text, #171A22)"
                        border="1px solid var(--calendar-border, #DBE5ED)"
                        onClick={handleClose}
                    >
                        Cancel
                    </StyledButton>

                    {isShowMessageButton && (
                        <StyledButton
                            backgroundColor="var(--calendar-action-primary-bg, #5B6EF5)"
                            color="#FFF"
                            onClick={handleSubmit}
                        >
                            {isEdit ? "Save Changes" : "Message"}
                        </StyledButton>
                    )}
                </div>
            </FlexContainer>
        );
    };

    if (usersList.length === 0) {
        return (
            <>
                <FlexContainer
                    style={{
                        height: "80%",
                        justifyContent: "center",
                        textAlign: "center",
                        marginTop: "20px"
                    }}
                >
                    {[USER_TYPE_EMPLOYEES, USER_TYPE_CLIENTS].includes(currentUserType)
                        ? "No user to display."
                        : "Please select a user list to display users."}
                </FlexContainer>
                {!hideFooter && renderFooterAction(false)}
            </>
        );
    }

    return (
        <>
            {children}
            {!hideFooter && renderFooterAction(true)}
        </>
    );
};

export default SelectUsersSection;
